var map = {
	"./agoda.png": "800b",
	"./airbnb.png": "d532",
	"./booking_com.png": "69a4",
	"./ebookers.png": "a119",
	"./expedia.png": "b198",
	"./google.png": "d337",
	"./holiday_check.png": "35cc",
	"./hotels_com.png": "cc24",
	"./hotels_de.png": "7dcc",
	"./orbitz.png": "855e",
	"./travelocity.png": "9ae8",
	"./trip_advisor.png": "cdac",
	"./wotif.png": "eaae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb96";